// extracted by mini-css-extract-plugin
export default {"selector":"DepartmentSelectionWizardStep_selector__lrn9b","fieldSelect":"DepartmentSelectionWizardStep_fieldSelect__oNJ-W"};